import { Component } from '@angular/core';
import { AddVehicleForm } from '../../components/garage/add-vehicle-form/add-vehicle-form';

@Component({
  selector: 'allas-agregar-vehiculo',
  imports: [AddVehicleForm],
  template: `<main class="p-2">
    <allas-add-vehicle-form></allas-add-vehicle-form>
  </main>`,
})
export class AgregarVehiculo {}
